export * from './platform-interact'

const ua = window.navigator.userAgent

/**
 * 是否是安卓系统
 */
export const isAndroid = /(android)/i.test(ua)

/**
 * 是否是app
 */
export const isApp = /renrenche/i.test(ua)

/**
 * 是否是微信小程序
 */
export const isWeapp = () => {
  return ua.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram'
}

/**
 * 是否是微信浏览器
 */
export const isWechat = () => {
  return /MicroMessenger/i.test(ua);
}

/**
 * 是否是 iOS
 */
 export const isIOS = () => {
  return /^.*((iPhone)|(iPad)|(Safari))+.*$/.test(ua);
}

// 评估师APP ua
export const INSPECTOR_APP = 'com.renrenche.carpublish'
// 商家版app
export const TOB_APP = 'com.renrenche.tobapp'
// 评估师app
export const IS_INSPECTOR_APP = ua.toLowerCase().indexOf(INSPECTOR_APP) > -1
// 人人车 加盟商app（原人人车商家版app）
export const IS_TOB_APP = ua.toLowerCase().indexOf(TOB_APP) > -1

// 是否58车商通app
export const isCstApp = ua.toLowerCase().indexOf('58cheshangtong') > -1 || (window.location.href.indexOf('isdev=true') > -1);